import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../components/Button";

import style from "./styles.module.scss";

const keyI18n = "translations.admin.notices.form.formatting";
const PANEL_ID = "notice-formatting-help";

const OPTIONS: { key: string; syntax: string; result: React.ReactNode }[] = [
  { key: "bold", syntax: "**texto**", result: <strong>texto</strong> },
  { key: "italic", syntax: "*texto*", result: <em>texto</em> },
  { key: "link", syntax: "[texto](https://endereco.com)", result: <u>texto</u> },
  { key: "list", syntax: "- item", result: "• item" },
  { key: "paragraph", syntax: "", result: null },
];

export default function FormattingHelp() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <div className={style.formatting}>
      <Button
        variant="text"
        size="small"
        type="button"
        className={style.formattingToggle}
        aria-expanded={open}
        aria-controls={PANEL_ID}
        onClick={() => setOpen((value) => !value)}
        icon={<span className="material-symbols-sharp">text_format</span>}
        trailingIcon={<span className="material-symbols-sharp">{open ? "expand_less" : "expand_more"}</span>}
      >
        {t(`${keyI18n}.toggle`)}
      </Button>

      {open && (
        <div id={PANEL_ID} className={style.formattingPanel}>
          <dl className={`pgm-body-medium ${style.formattingList}`}>
            {OPTIONS.map((option) => (
              <React.Fragment key={option.key}>
                <dt>{t(`${keyI18n}.options.${option.key}.label`)}</dt>
                <dd>
                  {option.syntax ? (
                    <>
                      <code>{option.syntax}</code>
                      {" → "}
                      {option.result}
                    </>
                  ) : (
                    t(`${keyI18n}.options.${option.key}.description`)
                  )}
                </dd>
              </React.Fragment>
            ))}
          </dl>
          <p className={`pgm-body-small ${style.formattingNote}`}>{t(`${keyI18n}.previewNote`)}</p>
        </div>
      )}
    </div>
  );
}
